// Module
var code = "<h2 id=\"not-sure-about-your-score\">Not Sure About Your Score?</h2> <p>You are entitled to a free credit report every 12 months from each of the three nationwide consumer reporting companies&mdash;Equifax, TransUnion, and Experian.</p> ";
// Exports
export default code;